
import { browserHistory } from 'react-router'
import { modal } from '../utilities/modal'
import { levelRenderer } from '../../core/graphic_engine/controllers/LevelRenderer'

var MultiTaskerManager = Class.create({
    taskObjs: [],
    didShowMax: false,
  	initialize: function() {
    },
    setData: function(data, type) {
        if(this.isDuplicate(data, type) || data === undefined || type === undefined) {
            return;
        }

        if(this.taskObjs.length == 3) {
            if(this.didShowMax) {
                this.didShowMax = false;
                return;
            }

            this.didShowMax = true;
            modal.showInfo("You can only show <b>3 task windows</b> at a time.  Try closing some to add more.", "info", "top", "center");
            return;
        }

        this.taskObjs.push({
            data: data,
            type: type
        });
    },
    isDuplicate: function(obj, type) {
        var duplicateFound = false;
        this.taskObjs.forEach(function(task) {
            if(task.type == 'space' && type == 'space') {
                if(Object.is(task.data.uuid, obj.uuid)) {
                    duplicateFound = true;
                }
            } else if(task.type == 'sensor' && type == 'sensor') {
                if(Object.is(task.data.uuid, obj.uuid)) {
                    duplicateFound = true;
                }
            } else {
                if(Object.is(task.data, obj)) {
                    duplicateFound = true;
                }
            }
        });

        return duplicateFound;
    },
    removeOne: function(position) {
        if(this.taskObjs[position].type === 'space') {
            const uuid = this.taskObjs[position].data.uuid;
            levelRenderer.clearSelectedSpaceState(uuid, undefined, true);
        } else if(this.taskObjs[position].type === 'sensor') {
            const uuid = this.taskObjs[position].data.uuid;
            levelRenderer.clearSelectedSpaceState(uuid, undefined, true);
        }
        this.taskObjs.splice(position,1);
    },
    setReload: function(reload) {
        this.reload = reload;
    },
    forceUpdate: function() {
        this.reload();
    }
});

export let multiTaskerManager = new MultiTaskerManager();


// WEBPACK FOOTER //
// app/core/controllers/MultiTaskerManager.js